export default __webpack_public_path__ + "static/custom-tooltips-5f95554138191bb62d165f642d02ab15.png";